import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useParams, useNavigate } from 'react-router-dom';
import CheckOutStyle from '../styles/pages/CheckOut.module.scss';
import PageHeader from '../components/layout/PageHeader'
import NotificationContainer from '../components/layout/NotificationContainer'
import { RootState } from '../store/GlobalStore';
import { useGetCheckOutFormQuery, useUpdateCheckOutMutation } from '../services/ReservationAPI';
import { setReservations } from '../store/slices/authSlice'
import { addNotification } from '../store/slices/notificationSlice'
import { useTranslation } from 'react-i18next';
const CheckOut: React.FC = () => {
  const { t, i18n  } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { asterioId } = useParams<{ asterioId: string }>();
  const { ressource } = useParams<{ ressource: string }>();
  const [alreadyCheckedIn, setAlreadyCheckedIn] = useState<boolean>(false);

  const [bookingResult, setBookingResult] = useState<any>(null);
  const authState = useSelector((state: RootState) => state.Auth);
  const { register, handleSubmit, watch, setValue } = useForm();

  const [updateCheckOut] = useUpdateCheckOutMutation();
  const reservations = authState?.reservations;
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const descriptionValue = watch('description', bookingResult?.Note || '');
  const {
    data: checkInData,
    refetch
  } = useGetCheckOutFormQuery(ressource || "");

  useEffect(() => {
    refetch(); // Rafraîchir les données lorsque la page est visitée
  }, [refetch]);

  useEffect(() => {
    const booking = findBooking(reservations, Number(asterioId), Number(id));
    setBookingResult(booking);
    console.log(bookingResult)
    if (booking) {
      setAlreadyCheckedIn(true);
    }
  }, [reservations, asterioId, id]);

  const findBooking = (reservations: any, asterioId: number, bookingId: number) => {
    const reservation = reservations?.find(
      (res: any) => res.asterioId === asterioId
    );
    if (!reservation) return null;
    const booking = reservation.Bookings?.find(
      (book: any) => book.bookingId === bookingId
    );
    return booking?.checkOut|| null;
  };

  // Nouvelle logique transformData inspirée de CheckIn
  function transformData(data: any) {
    const result: { [key: string]: { name: string; value: boolean }[] } = {};

    for (const key in data) {
      // Ignorer les clés qui ne suivent pas le format attendu
      if (key === "description" || typeof data[key] !== "boolean") {
        continue;
      }
      // key = id Field
      // rechercher le field et le title correspondant dans checkInData.Item
      const bookingField = checkInData?.Item.find(
        (item: any) => item.Field.some((field: any) => field.id === Number(key))
      );
      if (bookingField) {
        const fieldTitle = bookingField.Title;
        const fieldName = bookingField.Field.find(
          (field: any) => field.id === Number(key)
        )?.name ?? "";
        const value = data[key];
        if (!result[fieldTitle]) {
          result[fieldTitle] = [];
        }
        const temp: { name: string; value: boolean } = {
          name: fieldName,
          value: value,
        };
        result[fieldTitle].push(temp);
      }
    }
    // Convertir l'objet en tableau
    return Object.entries(result).map(([title, fields]) => ({
      Title: title,
      Field: fields,
    }));
  }

  const onSubmit = async (formData: any) => {
    const data = {
      asterioId: Number(asterioId),
      bookingId: Number(id),
      Item: transformData(formData),
      Note: formData.description,
    };
    console.log("DATAAAA ===> " + JSON.stringify(data))
    try {
      const result = await updateCheckOut(data);
      console.log('Update result:', result);
      if (result.data !== undefined) {
        dispatch(setReservations(result.data.reservations));
        dispatch(
          addNotification({
            message: "Le check-out a été effectué avec succès.",
            type: 'success'
          })
        );
        navigate('/mon-compte');
      } else if (result.error) {
        dispatch(addNotification({
          message: "<strong>Le check-out n'est pas encore ouvert</strong><br/>Veuillez réessayer plus tard ou vous rendre à l'accueil pour plus de renseignements",
          type: 'warning'
        }));
      }
    } catch (error) {
      console.error('Failed to update:', error);
    }
  };

  return (
    <>
      <NotificationContainer />
      <PageHeader backTo={`/booking/${id}`} title={t('sortie')} subtitle={t('sortie_sub')} />
      <form
        className={CheckOutStyle.ModifyLesseeForm}
        onSubmit={handleSubmit(onSubmit)}
      >
        {alreadyCheckedIn && Array.isArray(bookingResult?.Item) && bookingResult.Item.map((item: any, itemIndex: number) => (
          <div key={itemIndex} className={CheckOutStyle.Section}>
            <h3>{item.Title}</h3>
            {item.Subtitle ? (
              <p className={CheckOutStyle.SectionSubtitle}>{item.Subtitle}</p>
            ) : (
              <p className={CheckOutStyle.SectionSubtitle}>{t('indication_subtitle')}</p>
            )}
            {Array.isArray(item.Field) && item.Field.map((field: any, fieldIndex: number) => {
              // Affichage read-only, pas besoin de register
              return (
                <label
                  key={`${item.Title}_${field.name}`}
                  className={CheckOutStyle.checkboxContainer}
                >
                  <input
                    type="checkbox"
                    defaultChecked={field.value || false}
                    disabled={true}
                  />
                  <div className={CheckOutStyle.customCheckbox}></div>
                  <div className={CheckOutStyle.FieldName}>{field.name}</div>
                </label>
              );
            })}
          </div>
        ))}

        {!alreadyCheckedIn && checkInData?.Item && Array.isArray(checkInData.Item) && checkInData.Item.map((item: any, itemIndex: number) => (
          <div key={itemIndex}  className={CheckOutStyle.Section}>
            <h3>{item.Title}</h3>
            {item.Subtitle ? (
              <p className={CheckOutStyle.SectionSubtitle}>{item.Subtitle}</p>
            ) : (
              <p className={CheckOutStyle.SectionSubtitle}>{t('indication_subtitle')}</p>
            )}
            {Array.isArray(item.Field) && item.Field.map((field: any, fieldIndex: number) => {
              const fieldName = `${field.id}`;
              return (
                <label
                  key={`${item.Title}_${field.name}`}
                  className={CheckOutStyle.checkboxContainer}
                >
                  <input
                    type="checkbox"
                    {...register(fieldName)}
                    defaultChecked={field.value || false}
                  />
                  <div className={CheckOutStyle.customCheckbox}></div>
                  <div className={CheckOutStyle.FieldName}>{field.name}</div>
                </label>
              );
            })}
          </div>
        ))}

        <div className={CheckOutStyle.ModifyLesseeFormChild}>
          <div className={CheckOutStyle.DesktopFormField}>
            <h3>{t('remarque')}</h3>
            <div className={CheckOutStyle.TextAreaContainer}>
              <textarea
                id="description"
                {...register('description', { required: false })}
                defaultValue={bookingResult?.Note || ''}
                disabled={alreadyCheckedIn}
              />
              <label htmlFor="description">
                {(descriptionValue || bookingResult?.Note) ? "": t('comment')}
              </label>
            </div>
          </div>
        </div>

        {!alreadyCheckedIn && (
          <div className={CheckOutStyle.buttonContainer}>
            <Link to={`/booking/${id}`}>
              <button className={CheckOutStyle.Cancel}>{t('annuler')}</button>
            </Link>
            <button type="submit" className={CheckOutStyle.Update}>{t('send')}</button>
          </div>
        )}
      </form>
    </>
  );
};

export default CheckOut;
